import { Colors, Fonts } from '../../theme';

export default {
  // Normal Text
  textRegular10: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text10,
    color: Colors.black
  },
  textRegular12: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text12,
    color: Colors.black
  },
  textMedium12: {
    fontFamily: Fonts.type.KanitMedium,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.fakeBlack
  },
  textRegular14: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.black
  },
  textRegular14_whith: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  textRegular16: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.black
  },
  textRegular18: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text18,
    color: Colors.black
  },
  textRegular20: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text20,
    color: Colors.black
  },
  textRegular22: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text22,
    color: Colors.black
  },
  text10: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text10,
    color: Colors.black
  },
  text12: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text12,
    color: Colors.black
  },
  text14: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text14,
    color: Colors.black
  },
  text16: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text16,
    color: Colors.black
  },
  text18: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text18,
    color: Colors.black
  },
  text20: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text20,
    color: Colors.black
  },
  text22: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text22,
    color: Colors.black
  },

  // Special Text
  textDefault: {
    ...Fonts.style.textMessage,
    color: Colors.black
  },
  textTitle: {
    ...Fonts.style.headline,
    textAlign: 'center',
  } as React.CSSProperties,
  modalTitle: {
    ...Fonts.style.title
  },
  textModalHeader: {
    ...Fonts.style.textHeaderKanitSemiBold20,
    textAlign: 'center',
    color: Colors.font.primary.fakeBlack
  } as React.CSSProperties,
  textModalContent: {
    ...Fonts.style.textHeaderKanitRegular16,
    textAlign: 'center',
    color: Colors.font.primary.darkGray,
    whiteSpace: 'break-spaces'
  } as React.CSSProperties,
  notiTitle: {
    ...Fonts.style.subheader,
    fontFamily: 'DB-Heavent-Med',
    color: Colors.white
  },
  textLightRed: {
    ...Fonts.style.textcontentKanitRegular,
    color: Colors.lightRed,
  },
  textRed: {
    ...Fonts.style.textcontentKanitRegular,
    color: Colors.red,
  },
  textPurple: {
    ...Fonts.style.textMessage,
    color: Colors.scbPurple
  },
  textDarkOrchid: {
    ...Fonts.style.textMessage,
    color: Colors.darkOrchid,
  },
  textTopMenuOn: {
    ...Fonts.style.textTopMenu,
    color: Colors.white
  },
  textTopMenuOff: {
    ...Fonts.style.textTopMenu,
    color: Colors.font.primary.fakeBlack
  },
  textTopMenuLogout: {
    ...Fonts.style.textTopMenu,
    color: Colors.lightPurple,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  breadCrumb: {
    fontFamily: 'Kanit-Regular',
    lineHeight: '21px'
  },
  breadCrumbItem: {
    color: Colors.font.primary.darkGray
  },
  breadCrumbItemLink: {
    color: Colors.slipPurple
  },
  headerText: {
    ...Fonts.style.header,
  },
  exceptionHeader: {
    ...Fonts.style.textHeaderKanitRegular16,
    color: Colors.font.primary.fakeBlack,
    paddingBottom: 10
  },
  exceptionContent: {
    ...Fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray
  },
  exceptionButton: {
    ...Fonts.style.textRegularContent,
    color: Colors.font.primary.darkGray
  },
  textTableContent: {
    ...Fonts.style.textRegularContent,
    fontSize: Fonts.size.text12
  },
  textTableContentFakeBlack: {
    ...Fonts.style.textRegularContent,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.fakeBlack
  },
  textMediumFakeBlack: {
    ...Fonts.style.textMediumContent,
    fontSize: Fonts.size.text12,
    color: Colors.font.primary.fakeBlack
  },
  textRegularGray: {
    ...Fonts.style.textRegularHeader,
    color: Colors.font.primary.darkGray,
    fontSize: Fonts.size.text12
  },
  textRegularFakeBlack: {
    ...Fonts.style.textRegularHeader,
    color: Colors.font.primary.fakeBlack,
    fontSize: Fonts.size.text12
  },
  textTableContentPurple: {
    ...Fonts.style.textRegularContent,
    fontSize: Fonts.size.text12,
    color: Colors.scbPurple
  },
  textPaginationShowTotal: {
    ...Fonts.style.textRegularContent,
    fontSize: Fonts.size.text14
  },
  text16LightPurple: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text16,
    color: Colors.lightPurple
  },
  text16DarkPurple: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text16,
    color: Colors.darkPurple,
  },
  text16DarkPurpleUnderline: {
    fontFamily: Fonts.type.Kanit,
    fontSize: Fonts.size.text16,
    color: Colors.darkPurple,
    textDecoration: 'underline'
  },
  text16DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.darkGray,
    textAlign: 'center',
  },
  text16fakeBlack: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text16,
    color: Colors.font.primary.fakeBlack
  },
  formText: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.fakeBlack
  },
  textRegular14Gray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.gray
  },
  disabled: {
    opacity: '40%'
  },
  textTableContentOveflowY: {
    ...Fonts.style.textRegularContent,
    fontSize: Fonts.size.text12,
    overflowY: 'auto',
    height: '250px',
  },
};
